import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    /**
     * 全局
     */
    locale: 'id',
    currency: 'IDR',
    userInfo: {
      auditStatus: null,
      backImage: null,
      bankAccountNumber: '',
      bankAccountStatus: '',
      bankCode: '',
      countryCode: '',
      countryName: '',
      createTimestamp: null,
      credentialNumber: '',
      credentialStatus: '',
      credentialType: '',
      email: '',
      emailStatus: null,
      frontImage: '',
      fullName: '',
      id: '',
      jobType: '',
      lockedTimestamp: null,
      mobileNumber: '',
      password: null,
      status: '',
      updateTimestamp: null,
    },
    // 产品列表，包括 investment（标的） 和 product（产品）
    investments: {
      FIXED: [], // 定期产品
      FLEXIBLE: [], // 活期产品
      FIXED_TRIAL: [], // 体验标
      FIXED_NEO: [], // 新手标
    },
    fixedProducts: [], // 定期产品
    flexibleProducts: [], // 活期产品
    trialProducts: [], // 体验标
    newProducts: [], // 新手标
    // 新手标和体验标之类的活动，结构和 productList
    eventList: [],
    // 当前账户投资相关的字段
    accountOverview: [],
    // 用户全部优惠券
    couponList: [],

    /**
     * 具体页面相关
     */
    // 产品列表页，当前选中的产品，主页和产品页面需要
    currentProduct: {}, // 当前选中的产品
    // user-overview及子页面
    currentRecord: {}, // user页面中，从投资记录列表 -> 投资记录详情页 跳转时进行记录
    inviteCode: '', // 邀请好友 - 邀请码
  },
  getters: {
    loggedin: (state) => {
      return !!state.userInfo.id
    },
  },
  actions,
  mutations,
})
